import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LogEntry } from '../stores/LogStore';

const LogRow = ({ level, timestamp, message }) => (
  <p className={level}>
    <time dateTime={timestamp.format()}>{timestamp.format('MMM D HH:mm:ss')}</time>
    <span className='message'>{message}</span>
  </p>
);

LogRow.propTypes = {
  level: PropTypes.string,
  timestamp: PropTypes.instanceOf(moment).isRequired,
  message: PropTypes.string,
};

const LogView = ({ entries }) => (
  <div className='log'>
    {entries.map((l, i) => (
      <LogRow key={i} message={l.message} timestamp={l.timestamp} level={l.level} />
    ))}
  </div>
);

LogView.propTypes = {
  entries: ImmutablePropTypes.iterableOf(PropTypes.instanceOf(LogEntry)),
};

export default LogView;
